import { Toaster as RHToaster } from 'react-hot-toast'

/**
 * Modified to ensure consistent positioning
 */
export const Toaster = () => (
  <RHToaster
    position="bottom-right"
    containerClassName="inset-2!" // To align with e.g. Tooltip safe padding
  />
)
